import {
  ACCESS_TOKEN_STORAGE_KEY,
  REFRESH_TOKEN_STORAGE_KEY,
} from './storage-keys'

export interface AuthTokens {
  access_token: string
  refresh_token: string
}

export const getAccessToken = (): string | null =>
  localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY)

export const getRefreshToken = (): string | null =>
  localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY)

export const setAuthTokens = ({ access_token, refresh_token }: AuthTokens) => {
  localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, access_token)
  localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refresh_token)
}

export const clearAuthTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY)
  localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY)
}
